import { createReducer } from 'redux-create-reducer';

import {
  DEVICE_TYPES_FETCHING,
  DEVICE_TYPES_FETCHED,
  DEVICE_TYPES_FETCHED_ERROR,
} from '../actions/';

const initialState = {
  deviceTypesData: [],
  loading: false,
  error: '',
};

const events = {
  [DEVICE_TYPES_FETCHED]: (state, { deviceTypes }) => ({
    ...state,
    deviceTypesData: deviceTypes,
    loading: false,
    error: '',
  }),

  [DEVICE_TYPES_FETCHED_ERROR]: state => ({
    ...state,
    loading: false,
    error: 'Error fetching device types',
  }),

  [DEVICE_TYPES_FETCHING]: state => ({ ...state, loading: true }),
};

export default createReducer(initialState, events);
